(ns frontend.ui.page.lp-report-editor.common.modal.pdf-preview-modal 
  (:require
   [common.localization :as loc]
   [frontend.ui.component.modal-dialog.view :as modal-dialog]
   [frontend.ui.page.lp-report-editor.common.event :as common-event]
   [frontend.ui.page.lp-report-editor.common.style :as common-style]
   [frontend.ui.page.lp-report-editor.common.sub :as common-sub]
   [frontend.ui.page.lp-report-editor.common.view :as common-view]
   [herb.core :as h]
   [re-frame.core :as rf]
   [ui.components.button.view :as button]
   [ui.components.loading-spinner.view :as spinner]))

(defn view
  [{:keys [on-close report feeder? holding-report?]}]
  (let [preview-url @(rf/subscribe [::common-sub/pdf-preview-url])
        visible?    @(rf/subscribe [::common-sub/preview-mode?])]
    [modal-dialog/modal-dialog
     {:visible?     visible?
      :hide!        on-close
      :header-label (loc/tr :pdf-preview)
      :size         :xl}
     [:div {:style {:height "80vh"}}
      (if preview-url
        (let [pdfjs-url (str "/js/pdfjs/web/viewer.html"
                             "?file=" (js/encodeURIComponent preview-url))]
          [:iframe {:src    pdfjs-url
                    :width  "100%"
                    :height "100%"
                    :style  {:border "none"}}])
        [:div {:style {:height           "100%"
                       :display          "flex"
                       :justify-content  "center"
                       :align-items      "center"}}
         [spinner/circle]])]

     [:div
      {:class (h/<class common-style/footer-right)}
      (when-not holding-report?
        [common-view/pdf-button
         {:on-click #(rf/dispatch [::common-event/save-as-pdf report feeder?])}])
      [button/secondary-hollow
       {:on-click on-close}
       (loc/tr :close)]]]))


